"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _spauiUtils = require("@tencent/spaui-utils");

var _classnames = _interopRequireDefault(require("classnames"));

var _info = _interopRequireDefault(require("./info"));

var _list_props = require("./list_props");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * @class
 */
var List =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(List, _PureComponent);

  function List() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, List);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(List)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "handleScroll", function (event) {
      var onScroll = _this.props.onScroll;
      var scrollTop = event.target.scrollTop;
      var visibleHeight = event.target.clientHeight;
      var scrollHeight = event.target.scrollHeight;

      if ((0, _spauiUtils.isFunction)(onScroll)) {
        onScroll(event, [scrollTop, scrollTop + visibleHeight], scrollHeight);
      }
    });

    return _this;
  }

  _createClass(List, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if ((0, _spauiUtils.isFunction)(_spauiUtils.checkCssVersion)) {
        (0, _spauiUtils.checkCssVersion)(_info["default"]);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _classNames, _objectSpread2, _classNames2, _ref;

      var _this$props = this.props,
          data = _this$props.data,
          header = _this$props.header,
          footer = _this$props.footer,
          bordered = _this$props.bordered,
          hover = _this$props.hover,
          className = _this$props.className,
          baseClass = _this$props.baseClass,
          itemClassName = _this$props.itemClassName,
          itemActions = _this$props.itemActions,
          ItemComponent = _this$props.ItemComponent,
          ItemComponentProps = _this$props.ItemComponentProps,
          itemPadding = _this$props.itemPadding,
          _this$props$itemBorde = _this$props.itemBordered,
          itemBordered = _this$props$itemBorde === void 0 ? false : _this$props$itemBorde,
          itemRadius = _this$props.itemRadius,
          itemWidth = _this$props.itemWidth,
          itemHeight = _this$props.itemHeight,
          itemStyle = _this$props.itemStyle,
          ItemCheckComponent = _this$props.ItemCheckComponent,
          _this$props$itemDivid = _this$props.itemDivided,
          itemDivided = _this$props$itemDivid === void 0 ? true : _this$props$itemDivid,
          display = _this$props.display,
          cols = _this$props.cols,
          rows = _this$props.rows,
          gap = _this$props.gap,
          height = _this$props.height,
          width = _this$props.width,
          _this$props$overflow = _this$props.overflow,
          overflow = _this$props$overflow === void 0 ? 'auto' : _this$props$overflow,
          bodyClassName = _this$props.bodyClassName,
          onItemClick = _this$props.onItemClick,
          loading = _this$props.loading,
          _this$props$loadingTy = _this$props.loadingType,
          loadingType = _this$props$loadingTy === void 0 ? 'default' : _this$props$loadingTy,
          LoadingComponent = _this$props.LoadingComponent,
          ItemActionsComponent = _this$props.ItemActionsComponent,
          itemActionsClassName = _this$props.itemActionsClassName,
          ItemDataComponent = _this$props.ItemDataComponent,
          ItemDataComponentProps = _this$props.ItemDataComponentProps,
          EmptyDataComponent = _this$props.EmptyDataComponent,
          _this$props$showHelpO = _this$props.showHelpOnHover,
          showHelpOnHover = _this$props$showHelpO === void 0 ? true : _this$props$showHelpO,
          checkable = _this$props.checkable,
          bodyPadding = _this$props.bodyPadding,
          headerPadding = _this$props.headerPadding,
          footerPadding = _this$props.footerPadding,
          PopOverProps = _this$props.PopOverProps,
          OverlayTriggerProps = _this$props.OverlayTriggerProps,
          prefix = _this$props.prefix,
          suffix = _this$props.suffix,
          style = _this$props.style;
      var bodyContent = null;
      var loadingContent = loading ? _react["default"].createElement(LoadingComponent, {
        className: "".concat(baseClass, "-loading")
      }) : null;
      var len = data.length;

      if (len === 0 && !loading && !(0, _spauiUtils.isUndefined)(EmptyDataComponent)) {
        bodyContent = (0, _spauiUtils.isFunction)(EmptyDataComponent) ? _react["default"].createElement(EmptyDataComponent, null) : _react["default"].createElement("div", {
          className: "".concat(baseClass, "-empty-data")
        }, EmptyDataComponent);
      } else {
        bodyContent = !loading || loadingType === 'cover' ? data.map(function () {
          var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          var index = arguments.length > 1 ? arguments[1] : undefined;
          return _react["default"].createElement(ItemComponent, {
            key: index,
            itemClassName: (0, _classnames["default"])(itemClassName, {
              first: index === 0,
              last: index === len - 1,
              disabled: item.disabled
            }),
            ItemComponentProps: ItemComponentProps,
            itemActions: itemActions,
            itemActionsClassName: itemActionsClassName,
            ItemActionsComponent: ItemActionsComponent,
            ItemCheckComponent: ItemCheckComponent,
            ItemDataComponent: ItemDataComponent,
            ItemDataComponentProps: ItemDataComponentProps,
            itemWidth: itemWidth,
            itemHeight: itemHeight,
            itemStyle: itemStyle,
            baseClass: baseClass,
            onItemClick: !item.disabled && onItemClick,
            data: item,
            showHelpOnHover: showHelpOnHover,
            checkable: checkable,
            PopOverProps: PopOverProps,
            OverlayTriggerProps: OverlayTriggerProps,
            itemIndex: index
          });
        }) : loadingContent;
      }

      return _react["default"].createElement("div", _extends({
        role: "list",
        "aria-label": "list"
      }, (0, _spauiUtils.globalProps)(this.props, {
        className: (0, _classnames["default"])(baseClass, (_classNames = {}, _defineProperty(_classNames, "".concat(baseClass, "-bordered"), bordered), _defineProperty(_classNames, "".concat(baseClass, "-hover"), hover), _defineProperty(_classNames, "".concat(baseClass, "-has-loading"), loading), _defineProperty(_classNames, "".concat(baseClass, "-loading-").concat(loadingType), loadingType), _defineProperty(_classNames, "".concat(baseClass, "-has-divided"), itemDivided && !itemBordered), _classNames), className)
      }), {
        style: _objectSpread((_objectSpread2 = {}, _defineProperty(_objectSpread2, '--list-header-padding', headerPadding), _defineProperty(_objectSpread2, '--list-footer-padding', footerPadding), _objectSpread2), style)
      }), header ? _react["default"].createElement("div", {
        className: "".concat(baseClass, "-header")
      }, header) : null, _react["default"].createElement("div", {
        className: (0, _classnames["default"])("".concat(baseClass, "-body"), bodyClassName, (_classNames2 = {}, _defineProperty(_classNames2, "grid-cols-".concat(cols), cols), _defineProperty(_classNames2, "grid-rows-".concat(rows), rows), _classNames2)),
        onScroll: this.handleScroll,
        style: (_ref = {}, _defineProperty(_ref, '--list-body-padding', bodyPadding), _defineProperty(_ref, '--list-item-padding', itemPadding), _defineProperty(_ref, '--list-item-radius', itemRadius), _defineProperty(_ref, '--list-item-border-width', itemBordered ? '1px' : null), _defineProperty(_ref, "display", display), _defineProperty(_ref, "gap", gap), _defineProperty(_ref, "width", width), _defineProperty(_ref, "height", height), _defineProperty(_ref, "overflow", overflow), _ref)
      }, prefix, bodyContent, suffix, loadingType === 'cover' ? loadingContent : null), footer ? _react["default"].createElement("div", {
        className: "".concat(baseClass, "-footer")
      }, footer) : null);
    }
  }]);

  return List;
}(_react.PureComponent); // 组件标记


_defineProperty(List, "propTypes", _list_props.propTypes);

_defineProperty(List, "defaultProps", _list_props.defaultProps);

(0, _spauiUtils.setComponentMark)(List, _info["default"]); // 组件上报

(0, _spauiUtils.reportComponentUsage)(_objectSpread({
  scope: 'spaui'
}, _info["default"])); // 用于 focus 样式只在键盘索引时生效，而在鼠标操作时不生效

(0, _spauiUtils.initFocusManager)('spaui-focus-disabled');
var _default = List;
exports["default"] = _default;